import { ConfigModel } from "../Models";

const DEFAULT_ENV = "prod";
const LOCAL_HOST = "localhost";
const LOCAL_ENV = "dev01";
const ENVIRONMENTS = "environments";

const getEnvConfigKey = (data: any): ConfigModel => {
  let host = window.location.hostname;
  const updateHost = host.replace("rms.", "").replace("www.", "");
  const environmentObject = data[ENVIRONMENTS];
  const environmentKeys = Object.keys(environmentObject);
  const configKey = environmentKeys.find(
    (envKey: string) => environmentObject[envKey] === updateHost,
  );
  if (configKey && configKey === LOCAL_HOST) return data[LOCAL_ENV];
  else if (configKey) return data[configKey];
  else return data[DEFAULT_ENV];
};

export { getEnvConfigKey };
